<script>
export default {
  props: {
    documentData: {
      type: Object
    }
  },
  computed: {
    recipientInfo() {
      return this.documentData.recipientInfo || ''
    },
    recipientName() {
      return this.recipientInfo.recipient || ''
    },
    recipientAddress() {
      return this.recipientInfo.street
        ? this.recipientInfo.street + ' ' + this.recipientInfo.houseNumber
        : ''
    },
    recipientLocation() {
      return this.recipientInfo.zipCode
        ? this.recipientInfo.zipCode + ' ' + this.recipientInfo.city
        : ''
    },
    printMode() {
      return this.documentData.printMode
        ? this.$t(
          'component.documentValidation.validationResultDetailData.print.mode.'
          + this.documentData.printMode)
        : ''
    }
  }
}
</script>
<template>
  <v-card flat class="pa-0">
    <v-card-text class="pa-0">
      {{ $t('component.documentValidation.validationResultDetailData.check.document') }}
    </v-card-text>
    <v-card-title class="pl-0 pr-0">
      <h4>{{ $t('component.documentValidation.validationResultDetailData.recognized') }}</h4>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-row>
        <v-col>
          {{ $t('component.documentValidation.validationResultDetailData.recipient.info.header') }}<br />
          <span class="primary--text linebreak">{{ recipientName }}</span>
          <span v-if="recipientAddress" class="primary--text"
          ><br />{{ recipientAddress }}</span >
          <span v-if="recipientLocation" class="primary--text"
          ><br />{{ recipientLocation }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          {{ $t('component.documentValidation.validationResultDetailData.page.count.header') }}<br />
          <span class="primary--text">
            {{ documentData.pageCount }} - {{ printMode }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<style lang="scss" scoped>
.linebreak {
  white-space: pre-line;
}
</style>
